import { render, staticRenderFns } from "./PageStyleEditor.vue?vue&type=template&id=54266756&"
import script from "./PageStyleEditor.vue?vue&type=script&lang=js&"
export * from "./PageStyleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports